/*** IMPORTS FROM imports-loader ***/
var define = false;

import debounce from "./debounce";

const match = function (matchEl, widthEl) {
  // https://stackoverflow.com/questions/13672760/max-width-adjusts-to-fit-text
  // made a module out of this mainly to add the event listeners that we need

  // clear previous width so that widthEl can return to normal if it was affected by matchEl's previous width
  matchEl.style.removeProperty('width');

  // IE and Firefox prefer a small timeout before recalculating
  setTimeout(() => {
    // use getBoundingClientRect to get fractional pixels
    matchEl.style.width = `${widthEl.getBoundingClientRect().width}px`;
  }, 1);
}

export default {
  init: function () {
    const matchEls = document.querySelectorAll('[data-match-size]');
    matchEls.forEach((matchEl) => {
      // can only match size of ONE element for obvious reasons, so use querySelector
      const widthEl = document.querySelector(matchEl.dataset.matchSize);
      match(matchEl, widthEl);

      const matchThis = function ()
      {
        match(matchEl, widthEl);
      }
      window.addEventListener('resize', debounce(matchThis, 15));

      // detects event from disciplineFilter.js
      widthEl.addEventListener('updatedSize', () => match(matchEl, widthEl));
    });
  },
}

